import { useEquities } from "@/hooks/useEquities";
import { QuoteIndexCard, QuoteTickerRow } from "@/components/markets/QuoteCards";

export default function MarketPulsePanel() {
  const { data, isLoading } = useEquities();
  const indices = data?.indices ?? [];
  const stocks = data?.tech_stocks ?? [];

  if (isLoading) {
    return (
      <div className="mb-6 grid grid-cols-2 gap-3 md:grid-cols-3">
        {[0, 1, 2].map(i => (
          <div key={i} className="h-32 animate-pulse rounded-2xl border border-border bg-muted/40" />
        ))}
      </div>
    );
  }

  if (indices.length === 0 && stocks.length === 0) return null;

  return (
    <section className="mb-6">
      <div className="mb-3 font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
        Market pulse &mdash; indices &amp; tech equities
      </div>

      {indices.length > 0 && (
        <div className="mb-3 grid grid-cols-2 gap-3 md:grid-cols-3">
          {indices.map(q => (
            <QuoteIndexCard key={q.symbol} q={q} />
          ))}
        </div>
      )}

      {stocks.length > 0 && (
        <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
          {stocks.map(s => (
            <QuoteTickerRow key={s.symbol} q={s} />
          ))}
        </div>
      )}
    </section>
  );
}
